// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./assets/styles/common.scss
 ** module id = 5
 ** module chunks = 0 1
 **/